<template>
  <div class="ranking_warp" :class="{ active: showDetailPanel, down: showBackBtn }">
    <div class="back_list" :class="{ active: !showDetailPanel && showBackBtn }" v-if="showBackBtn" @click="backPrev();">
      <i class="el-icon-arrow-left"></i>
      <div class="back_con">
        <span>返回到"</span>
        <span class="text_area">{{ aeraInfo.name }}</span>
        <span>"分布情况</span>
      </div>
    </div>
    <div class="back_bar" :class="{ active: showDetailPanel }">
      <div class="ranking_btn" @click=" showDetailPanel = !showDetailPanel">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <div class="ranking_btn" :class="{ hide: activeName != '' && activeName.indexOf('_1') > -1 }"
        @click=" showDetailPanel = !showDetailPanel">
        <div>
          <img :src="require('@/assets/map/detail_t_icon.png')" alt="">
          <span>{{ currAeraName }}</span>
        </div>
        <i class="el-icon-d-arrow-right"></i>
      </div>
    </div>
    <div class="ranking_panel" :class="{ active: activeName != '' && activeName.indexOf('_1') > -1 }">
      <!-- 基本信息 -->
      <div class="ranking_list" v-if="showCharts">
        <div class="group_panel">
          <div class="panel_title" v-if="!showBackBtn">
            <el-popover placement="left-start" popper-class="tips-popper" width="200" trigger="hover">
              <div class="tips_panel">
                <div class="tips_item" v-for="(item, index) in purgeInfo" :key="index">
                  <div class="item_text">{{ item.title }}</div>
                  <div class="item_num">{{ item.value }}</div>
                </div>
              </div>
              <div slot="reference">
                <div class="tips_btn"><span>基本信息</span><span>存在待清洗数据</span></div>
              </div>
            </el-popover>
          </div>
          <div class="panel_title" v-else>基本信息</div>
          <div class="panel_body">
            <div class="group_list">
              <div class="list_item" v-for="(item, index) in baseInfo" :key="index">
                <div class="item_text">{{ item.title }}</div>
                <div class="item_num">{{ item.value }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="group_panel">
          <div class="panel_title">{{ aeraInfo.name == '全国' ? '各省' : '各地区' }}资源排行</div>
          <div class="panel_body">
            <div class="group_charts_panel" v-for="item in chartsList">
              <div class="group_charts" v-show="item.visible">
                <div class="charts_title">{{ item.name }}</div>
                <div class="charts_con">
                  <ColumnChart :ref="'column_' + item.id" @setMap="setMap" @setCon="setCon">
                  </ColumnChart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 列表及详情 -->
      <div class="list_panel" v-if="showList">
        <!-- 服务人员、终端、渠道 列表 -->
        <div v-if="activeName != '' && activeName.indexOf('_1') == -1"
          :class="{ 'sales_panel': activeName == 'tab1', 'channel_panel': activeName == 'tab2' || activeName == 'tab3' }">
          <div class="list_group" v-for="(item, index) in resultData.slice(0, 10)" :key="index">
            <div class="list_group_content" @click=" showDetailData(item, 1)">
              <div class="list_group_head">
                <div class="group_head_title">
                  <div class="head_title" v-if="activeName == 'tab1'">
                    <strong class="title_text">{{ item.name }}</strong>
                    <div class="title_label" v-if="item.isActive == 1">
                      <img :src="require('@/assets/hotspot.png')" />活跃
                    </div>
                  </div>
                  <div class="head_title" v-else>
                    <strong class="title_text">石嘴山市立恒光大医药有限公司</strong>
                  </div>
                  <div class="group_head_tool" v-if="item.isActive == 1">
                    平台评分&nbsp;&nbsp;<span class="head_tags_item">{{
                      item.totalScore == 0 ? '--' : item.totalScore > 100 ? 100 : item.totalScore
                    }}</span>
                  </div>
                </div>
                <div class="head_tags" v-if="activeName == 'tab1'">
                  <span class="tag_text" v-for="(tag, t) in item.tags" :key="'ht_' + t">{{
                    tagValue(tag)
                  }}</span>
                </div>
                <div class="head_tags" v-else>
                  <span class="tag_text">民营企业</span>
                  <span class="tag_text">中小流通</span>
                  <span class="tag_text">10年以上</span>
                </div>
              </div>
            </div>
          </div>
          <div class="list_btn" v-if="resultData.length > 10" @click=" toDetail('list')">查看更多>></div>
          <div class="list_group" v-if="resultData.length == 0">
            <div class="empty_tips">暂无信息</div>
          </div>
        </div>
        <!-- 服务人员、终端、渠道 详情 -->
        <div v-if="activeName != '' && activeName.indexOf('_1') > -1" class="detail_panel"
          :class="{ 'list_detail': activeName == 'tab1_1', 'list_panel_r': activeName == 'tab3_1' }">
          <div class="list_group" v-for="(     detail, d     ) in detailData     " :key="'det_' + d">
            <div class="list_group_content">
              <div class="list_group_head">
                <div class="group_head_title">
                  <div class="head_title">
                    <strong class="title_text" @click=" toDetail('detail')">{{
                      detail.name
                    }}</strong>
                    <div class="title_label" v-if="detail.isActive == 1 && activeName == 'tab1_1'">
                      <img :src="require('@/assets/hotspot.png')" />活跃
                    </div>
                  </div>
                  <i class="el-icon-d-arrow-right" @click=" showDetailPanel = false"></i>
                </div>
                <div class="head_posit" v-if="activeName != 'tab1_1'">
                  <img class="posit_icon" :src="require('@/assets/map/mark_icon.png')" alt="">
                  <span>{{ detail.address }}</span>
                </div>
                <div class="head_tags">
                  <span class="tag_text" v-for="(tag, t) in detail.tags" :key="'ht_' + t">{{
                    tagValue(tag)
                  }}</span>
                </div>
              </div>
              <div class="list_group_body">
                <div class="group_item" v-for="(list, l) in detail.list" :key="l">
                  <div class="group_item_filed" v-if="(l % 2) == 0">
                    {{ l == 0 && activeName == 'tab2_1' ? '成立时间' : l == 2 && activeName == 'tab2_1' ?
                      '联系人' : l == 4 && activeName == 'tab2_1' ? '联系电话' : list.label }}:
                  </div>
                  <div class="group_item_value" v-if="(l % 2) == 0 && (list.net != undefined)">
                    <span class="item_label">{{ list.label }}</span>
                    <div class="item_tag">{{ list.net }} <i class="el-icon-arrow-right"></i>
                    </div>
                  </div>
                  <div class="group_item_value" v-if="(l % 2) == 0">
                    {{ list.value }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 人员详情 -->
          <div class="customer_panel" v-if="activeName == 'tab1_1'">
            <div class="panel_title">近期拜访客户</div>
            <div class="list_group" v-for="(item, i) in visitList" :key="i">
              <div class="group_icon rank_num" :class="{ 'one': i == 0, 'tow': i == 1, 'three': i == 2 }">
                {{ (i + 1) }}
              </div>
              <div class="group_cont">
                <div class="list_title" @click=" showDetailData(item)">{{ item.custName }}</div>
                <div class="list_panel">
                  <span class="item_tag">{{ item.newestMaintainTime }}</span>
                </div>
              </div>
            </div>
            <div class="list_group" v-if="visitList.length == 0">
              <div class="empty_tips">暂无信息</div>
            </div>
          </div>
          <!-- 终端详情 -->
          <div class="customer_panel" v-else-if="activeName == 'tab2_1'">
            <div class="panel_title">热门商品</div>
            <div class="group_charts">
              <div class="charts_con">
                <ColumnChart ref="goods" @setCon="setCon"></ColumnChart>
              </div>
            </div>
          </div>
          <!-- 渠道详情 -->
          <div class="customer_panel" v-else-if="activeName == 'tab3_1'">
            <!-- 会员 -->
            <div class="group_panel" v-if="isSSAS">
              <div class="panel_title">基本信息</div>
              <div class="panel_body">
                <div class="group_list card_list">
                  <div class="list_item" v-for="(item, index) in clickableInfo" :key="index"
                    :class="{ active: selectIndex == index }" @click=" getRelateInfo(item, index)">
                    <div class="item_text">{{ item.title }}</div>
                    <div class="item_num">{{ item.value }}</div>
                  </div>
                </div>
                <div class="group_list">
                  <div class="list_item" v-for="(item, index) in notClickableInfo" :key="index">
                    <div class="item_text">{{ item.title }}</div>
                    <div class="item_num">{{ item.value }}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 非会员 -->
            <div class="group_panel" v-else>
              <div class="panel_title">合作药企</div>
              <div class="panel_body channel_panel" v-if="businessList.length">
                <div class="list_group" v-for="(item, c) in businessList" :key="'business_' + c">
                  <div class="list_group_content">
                    <div class="list_group_head">
                      <div class="group_head_title">
                        <div class="head_title">
                          <strong class="title_text">{{ item.name }}</strong>
                        </div>
                      </div>
                      <div class="head_tags">
                        <span class="tag_text" v-for="(tag, t) in item.tags" :key="'bus_' + t">{{
                          tagValue(tag) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="panel_body channel_panel" v-else>
                <div class="empty_tips">暂无信息</div>
              </div>
            </div>
          </div>
          <!-- 关系快查 -->
          <div class="graph_search_panel" v-if="false">
            <div class="panel_title">
              <span>关系快查</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="panel_con">
              <div class="tool_btns">
                <el-button class="tool_btn" round size="mini">人员关系</el-button>
                <el-button class="tool_btn" round size="mini">终端关系</el-button>
                <el-button class="tool_btn" round size="mini">渠道关系</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ColumnChart from '../charts/columnChart.vue';
import {
  changeNum,
  typeFilter,
  setBaseInfo,
  getOrgTotalData,
  getOrgRankingData,
  getOrgMedmiddleList,
  getVisitList,
  getNomemberDetailStat,
  getNomemberMedcircRankData,
  getRankingInfo,
  getMedmiddleInfo,
  getTerminalInfo,
  getChannelInfo,
} from '@/api/portrait.js'
export default {
  components: {
    ColumnChart
  },
  data() {
    return {
      showBackBtn: false,
      aeraInfo: { name: '全国', level: 'coun' },
      currAeraName: '全国',
      channelName: '',
      showDetailPanel: false,
      showCharts: true,
      showList: false,
      isSSAS: false,
      idCard: '',
      detailData: [],
      rankList: [],
      baseInfo: [],
      purgeInfo: [],
      chartsList: [],
      resultData: [],
      activeName: '',
      tabList: [
        {
          id: 1,
          name: '服务人员',
          count: 1020
        }, {
          id: 2,
          name: '终端',
          count: 100
        }, {
          id: 3,
          name: '渠道',
          count: 30
        }
      ],
      listTab: '1',
      visitList: [],
      clickableInfo: [],
      selectIndex: -1,
      notClickableInfo: [],
      businessList: [],
      restricted: false,
    }
  },
  methods: {
    setNum(val) {
      return changeNum(val)
    },
    tagValue(row) {
      return typeFilter(row)
    },
    backPrev() {
      this.$emit('toPrevLevel', this.aeraInfo)
    },
    setMap(row) {
      let level = this.aeraInfo.level
      if (level == 'coun') {
        row.level = 0
      } else if (level == 'prov') {
        row.level = 1
      } else if (level == 'city') {
        row.level = 2
      } else if (level == 'dist') {
        row.level = 3
      }
      row.code = Number(row.code)
      this.$emit('drillMap', row)
    },
    // 设置父元素高度
    setCon(ref, rh) {
      let parentNode = ref.parentNode.parentNode
      if (rh > 0) {
        parentNode.style.height = rh + 'px'
      } else {
        parentNode.style.height = 'auto'
      }
    },
    // 显示详情并定位
    showDetailData(row, st) {
      let type = st ? st : row.custType.indexOf('终端') > -1 ? 2 : 3
      let info = {
        id: row.idCard || row.damId,
        level: row.level || 3,
        type
      }
      this.getDetailInfo(info)
      if (type == 1) {
        let param = {
          id: row.idCard || row.damId,
          toPosit: true,
          type
        }
        this.$emit('getRelated', param)
      } else {
        if (row.lat && row.lng) {
          let param = {
            id: row.idCard || row.damId,
            code: row.code,
            level: row.level || 3,
            toPosit: true,
            type
          }
          this.$emit('getRelated', param)
        } else {
          this.$message('该数据暂无位置信息');
        }
      }
    },
    // 获取会员渠道 人员、终端数据
    getRelateInfo(row, i) {
      if (this.selectIndex == i) {
        this.restricted = !this.restricted
        this.selectIndex = -1
      } else {
        this.restricted = true
        this.selectIndex = i
      }
      let info = {
        id: this.idCard,
        name: this.restricted ? row.name : ''
      }
      if (this.restricted) {
        info.type = row.field == 'medmiddleStatValue' ? 1 : 2
      } else {
        this.showBackBtn = false
        this.showDetailPanel = false
        this.activeName = ''
      }
      this.$emit('getRelated', info)
    },
    // 获取详情信息
    getDetailInfo(param) {
      if (this.restricted) return
      let params = param ? param : { level: 0, type: [1, 2, 3], code: '' }
      if (params.level < 3) {
        this.showCharts = true
        this.showList = false
        // 基本信息
        getOrgTotalData(params).then(res => {
          let data = res.data
          this.baseInfo = [
            { title: '服务人员数量', value: changeNum(data.medBrokerNum) },
            { title: '终端数量', value: changeNum(data.terminalNum) },
            { title: '渠道数量', value: changeNum(data.channelNum) }
          ]
          if (this.purgeInfo.length == 0) {
            this.purgeInfo = [
              { title: '服务人员数量', value: changeNum(data.noMedBrokerNum) },
              { title: '终端数量', value: changeNum(data.noTerminalNum) },
              { title: '渠道数量', value: changeNum(data.noChannelNum) }
            ]
          }
        })
        // 排行榜
        getOrgRankingData(params).then(res => {
          let data = res.data
          if (data) {
            this.chartsList.map(item => {
              if (data[item.id]) {
                item.data = data[item.id]
              }
            })

            this.$nextTick(() => {
              if (this.showCharts) {
                this.chartsLoad()
              }
            })
          }
        })
      } else {
        this.showCharts = false
        this.showList = true
        if (Array.isArray(params.type)) {
          if (params.type.indexOf(1) > -1) {
            getOrgMedmiddleList({ code: params.code, damId: '', limit: 11 }).then(res => {
              let data = res.data
              if (data.length) {
                data.map(item => {
                  return setBaseInfo(item, 1)
                })
              }
              this.activeName = 'tab1'
              this.resultData = data
            })
          }
        } else {
          let method = null, type = params.type, id = params.id || params.idCard || params.damId
          if (type == '1') {
            method = getMedmiddleInfo({ idCard: id })
          } else if (type == '2') {
            method = getTerminalInfo({ damId: id })
          } else if (type == '3') {
            method = getChannelInfo({ damId: id })
          }
          method.then(res => {
            let data = res.data.records ? res.data.records : []
            data = data.map(item => {
              return item = setBaseInfo(item, type)
            })
            this.showDetail(data[0], type)
          })
        }
      }
    },
    // 加载图表
    chartsLoad() {
      let _this = this
      this.chartsList.map(item => {
        if (item.visible) {
          _this.$nextTick(() => {
            _this.$refs['column_' + item.id][0].chartName = 'home_' + item.id
            _this.$refs['column_' + item.id][0].setOption(item.data)
          })
        }
      })
    },
    // 详情
    showDetail(row, type) {
      this.idCard = row.idCard || row.damId || ''
      this.aeraInfo.name = this.currAeraName
      this.aeraInfo.level = 'town'
      this.detailData = [row]

      if (type == 1) {
        this.activeName = 'tab1_1'
        // 服务人拜访数据top5
        getVisitList({ idCard: this.idCard }).then(res => {
          let data = res.data
          this.visitList = data
          if (data && data.length) {
            let info = {
              code: this.visitList[0].code,
              level: this.visitList[0].level,
            }
            this.$emit('getAera', info)
          }
        })
      } else if (type == 2) {
        this.activeName = 'tab2_1'
        // 获取热销商品
        getRankingInfo({ damId: this.idCard }).then(res => {
          this.$nextTick(() => {
            this.$refs.goods.chartName = 'goods'
            this.$refs.goods.setOption(res.data)
          })
        })
      } else {
        this.activeName = 'tab3_1'
        this.isSSAS = row.isMember == '是'
        if (this.isSSAS) {
          getNomemberDetailStat({ damId: this.idCard }).then(res => {
            let data = res.data
            this.clickableInfo = [
              { title: '服务人员', value: changeNum(data.medmiddleStatValue), name: row.name },
              { title: '覆盖终端数', value: changeNum(data.terminalNum), name: row.name },
            ]
            this.notClickableInfo = [
              { title: '覆盖城市数', value: changeNum(data.cityNum) },
              { title: '覆盖科室数', value: changeNum(data.deptNum) },
              { title: '覆盖医生数', value: changeNum(data.doctNum) },
            ]
          })
        } else {
          // 渠道非会员合作药企
          getNomemberMedcircRankData({ damId: this.idCard }).then(res => {
            let data = res.data.rankData
            if (data.length) {
              data.map(item => {
                return setBaseInfo(item, 3)
              })
            }
            this.businessList = data
          })
        }

      }
    },
    // 跳转至详情页
    toDetail(route) {
      let type = this.activeName.indexOf('tab1') > -1 ? 1 : this.activeName.indexOf('tab2') > -1 ? 2 : 3
      if (route == 'detail') {
        let queryInfo = this.$route.query
        let row = this.detailData[0]
        let info = setBaseInfo(row, type)
        queryInfo.data = JSON.stringify([info])
        queryInfo.type = type
        queryInfo.from = 'home'
        delete queryInfo.fUrl;
        delete queryInfo.loginInfo;
        queryInfo.localInfo = JSON.stringify({ token: localStorage.token, guid: localStorage.guid });
        let pathInfo = this.$router.resolve({
          path: '/portraitDetail',
          query: queryInfo
        })
        window.open(pathInfo.href, '_blank');
      } else {
        this.$emit('getPrevInfo', route, type)
      }
    },
  }
}
</script>
<style lang="less">
.ranking_warp {
  width: 408px;
  height: calc(100vh - 9rem);
  position: absolute;
  top: 3rem;
  right: -408px;
  z-index: 20;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.2);
  transition: all .3s;

  &.active {
    right: .5rem;
  }

  &.down {
    top: 6.5rem;
    height: calc(100vh - 12.5rem);
  }

  .back_bar {
    width: 100%;
    height: 60px;
    background: rgba(0, 0, 0, .5);
    color: #212121;
    font-size: 16px;
    font-weight: 600;
    text-align: left;
    position: absolute;
    top: 0;
    left: -1.5rem;
    transition: all .3s;

    .ranking_btn {
      width: calc(100% - 30px);
      height: 100%;
      padding: 0 15px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;
      user-select: none;
      opacity: 0;

      img {
        width: 24px;
        vertical-align: bottom;
        margin-right: 5px;
      }

      >i {
        font-size: 20px;
        color: #212121;
      }

      &:first-child {
        padding: 0;
        z-index: 1;
        opacity: 1;

        >i {
          color: #fff;
          margin-left: 2px;
        }
      }

    }

    &.active {
      background: #fff;
      left: 0;

      .ranking_btn {
        &:first-child {
          z-index: 0;
          opacity: 0;
        }

        &:last-child {
          z-index: 1;
          opacity: 1;
        }

        &.hide {
          left: 110%;
        }
      }
    }
  }

  .back_list {
    width: calc(100% - 20px);
    height: 40px;
    padding: 0 10px;
    background: #fff;
    box-shadow: 0px 4px 10px 0px rgb(0 0 0 / 20%);
    display: flex;
    align-items: center;
    cursor: pointer;
    position: absolute;
    top: -50px;
    left: 0;
    transition: all .3s;

    &.active {
      left: calc(-100% - 0.5rem);
    }

    >i {
      color: #666;
    }

    .back_con {
      margin-left: 5px;
      color: #212121;
      font-size: 12px;

      .text_area {
        color: #4FA1A4;
      }
    }
  }

  .ranking_panel {
    width: 100%;
    height: calc(100% - 60px);
    background: #fff;
    position: absolute;
    top: 60px;
    overflow: hidden auto;
    transition: all .3s;

    &::-webkit-scrollbar {
      width: 2px;
      height: 4px;
    }

    &.active {
      height: 100%;
      top: 0;
    }

    .ranking_list {
      background: #fff;
      min-height: 100%;
    }

    .list_panel {
      .customer_panel {
        text-align: left;
        color: #212121;

        .panel_title {
          padding: 10px 15px;
          position: relative;

          &::before {
            content: '';
            width: calc(100% - 20px);
            border-top: 1px solid #e5e5e5;
            position: absolute;
            left: 10px;
            top: 0;
          }
        }

        .list_group {
          display: flex;
          text-align: left;

          &:hover {
            background-color: #f5f5f5;

            .group_title {
              color: #4FA1A4;
            }
          }
        }

        .group_icon {
          width: 20px;
          height: 20px;
          border-radius: 20px;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          background: #d9d9d9;
          color: #fff;
          margin: 6px 10px 0 0;

          &.one {
            background: #fb2323;
          }

          &.tow {
            background: #5797ff;
          }

          &.three {
            background: #ffd52e;
          }
        }

        .group_cont {
          width: calc(100% - 30px);

          .list_title {
            font-size: 14px;
            color: #212121;
            line-height: 30px;
            font-weight: 600;
            padding: 0 15px 0 0;
            cursor: pointer;

            &:hover {
              color: #4FA1A4;
            }
          }

          .list_panel {
            display: flex;

            .item_tag {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }

    }

    >.list_panel {
      background: #fff;
      height: 100%;
    }

    .group_panel {
      padding: 0 10px;

      &+.group_panel {
        padding-top: 15px;
      }

      .panel_title {
        background: #f2f2f2;
        height: 25px;
        line-height: 25px;
        text-align: left;
        padding: 0 10px;
        color: #212121;
        font-weight: 400;
      }

      .panel_body {
        // padding: 15px 0;

        .group_list {
          padding: 15px 0 0;
          display: flex;
          flex-wrap: wrap;

          .list_item {
            // width: calc(33.33% - 20px);
            flex: 1;
            padding: 0 10px;
            text-align: left;
            color: #666;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            &+.list_item {
              position: relative;

              &::before {
                content: '';
                width: 1px;
                height: 80%;
                background-color: #e5e5e5;
                position: absolute;
                left: -1px;
                top: 50%;
                transform: translateY(-50%);
              }
            }

            .item_text {
              margin-bottom: 5px;
            }

            .item_num {
              font-weight: 600;
              color: #212121;
            }

          }
        }

        .group_charts_panel {
          &+.group_charts_panel {
            border-top: 1px solid #e5e5e5;
          }
        }
      }
    }

    .group_charts {
      text-align: left;
      color: #212121;
      font-weight: 400;
      padding: 15px 10px;

      &+.group_charts {
        border-top: 1px solid #d9d9d9;
      }
    }

    .charts_title {
      margin-bottom: 10px;
    }

    .charts_con {
      height: 260px;
      // overflow: hidden auto;
    }

    .sales_panel {
      background: #fff;
      height: 100%;
      overflow: hidden auto;

      &::-webkit-scrollbar {
        width: 2px;
        height: 4px;
      }
    }

    .list_btn {
      float: right;
      padding: 5px;
      margin: 0 10px 10px;
      font-size: 12px;
      color: #4fa1a4;
      border: 1px solid #4fa1a4;
      border-radius: 2px;
      cursor: pointer;
    }

    .list_group {
      padding: 10px 15px;
      position: relative;

      // +.list_group {
      //     &::before {
      //         content: '';
      //         width: calc(100% - 30px);
      //         height: 1px;
      //         background: #d8d8d8;
      //         position: absolute;
      //         left: 15px;
      //         top: 0;
      //     }
      // }

      &:hover {
        background-color: #f5f5f5;
      }

      &_head {
        text-align: left;

        .group_head_title {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .head_title {
            display: flex;
            align-items: center;
            margin-bottom: 10px;

            .title_text {
              font-size: 16px;
              color: #212121;
              line-height: 24px;
              font-weight: 600;
              margin-right: 10px;
            }

            .title_label {
              width: 60px;
              height: 20px;
              line-height: 20px;
              font-size: 12px;
              color: #FF8831;
              background: #FFF9F5;
              border-radius: 10px;

              >img {
                width: 20px;
                height: 18px;
                margin: -2px 2px 0 4px;
                vertical-align: middle;
              }
            }
          }

          >i {
            font-size: 18px;
            color: #666;
          }
        }

        .group_head_tool {
          font-size: 12px;
          color: #666;
          line-height: 30px;

          .head_tags_item {
            font-size: 16px;
            color: #FF5F1F;
            font-weight: 500;
            vertical-align: bottom;
          }
        }

        .head_tags {
          .tag_text {
            display: inline-block;
            font-size: 12px;
            color: #666;
            margin: 0 5px 5px 0;
            padding: 3px 5px;
            background: #F5F5F5;
            border-radius: 2px;
          }
        }

        .head_posit {
          margin-bottom: 10px;

          .posit_icon {
            width: 18px;
            margin-right: 10px;
            vertical-align: text-bottom;
          }
        }
      }

      &_body {
        display: flex;
        line-height: 30px;
        flex-wrap: wrap;

        .group_item {
          width: 100%;
          text-align: left;
          display: flex;

          &_filed {
            width: 80px;
            color: #666;
          }

          &_value {
            width: calc(100% - 80px);
            color: #212121;
          }

        }
      }

    }

    .list_detail {
      background: #fff;

      .list_group:hover {
        background-color: #fff;
      }

    }

    .channel_panel {
      .list_group_head .group_head_title .head_title .title_text {
        font-size: 14px;
        font-weight: normal;
      }

      .list_group {
        &:hover {
          .list_group_head .group_head_title .head_title .title_text {
            color: #4FA1A4;
          }
        }
      }

      &.panel_body {
        .list_group {
          &:hover {
            .list_group_head .group_head_title .head_title .title_text {
              color: #212121;
            }
          }
        }
      }
    }

    .detail_panel {

      // padding-bottom: 10px;
      .group_panel {
        padding: 10px 0;
        margin: 0 15px;
        border-top: 1px solid #e5e5e5;
      }

      >.list_group {
        padding-bottom: 5px;
      }

      .list_group {
        &:hover {
          background-color: #fff
        }
      }

      .list_group_head .group_head_title .head_title {
        margin-top: 10px;
        cursor: pointer;

        &:hover {
          .title_text {
            color: #4FA1A4;
          }
        }
      }

      &.list_panel_r {
        .customer_panel {
          .group_panel {
            padding-bottom: 0;
          }

          .panel_title {
            margin: 0;
            padding: 0 10px;
            line-height: 25px;
          }
        }
      }

      .group_list.card_list {
        .list_item {
          flex: 1;
          padding: 10px;
          background-color: #f5f5f5;
          margin: 0 5px 5px 0;
          cursor: pointer;

          &+.list_item::before {
            display: none;
          }

          &:hover,
          &.active {
            background-color: #ecf5ff;
          }
        }
      }

      .graph_search_panel {
        text-align: left;

        .panel_title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 15px 0 10px;
          margin: 10px 15px 0;
          border-top: 1px solid #e5e5e5;
        }

        .panel_con {
          .tool_btns {
            padding: 10px 15px;

            button {
              margin-bottom: 5px;

              &.tool_btn {
                border-color: #d9d9d9;
                color: #404040;

                &.active,
                &:hover {
                  background-color: #fff;
                  border-color: #4fa1a4;
                  color: #4fa1a4;
                }
              }
            }
          }
        }

      }

      .channel_panel {
        margin-top: 10px;

        .list_group {
          padding: 10px;
        }
      }

      .group_charts {
        padding: 0 15px 10px;
      }
    }
  }

  .empty_tips {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    color: #999;
  }
}
</style>
